import { observer } from 'mobx-react-lite'
import { Id } from '@/infra/id'
import { type InventoryItemRowViewModel } from '@/features/inventory/admin/InventoryItemRowViewModel'
import { type InventoryColumnDetails } from '@/features/inventory/admin/inventory-table-columns'
import { InventoryRow } from '@/features/inventory/admin/components/InventoryRow'

export interface InventoryRowContainerProps {
  vm: InventoryItemRowViewModel
  columns: InventoryColumnDetails[]
}

export const InventoryRowContainer = observer(function InventoryRowContainer({
  vm,
  columns,
}: InventoryRowContainerProps) {
  const inventoryItem = vm.inventoryItem

  return (
    <InventoryRow
      columns={columns.map((column) => ({
        id: column.id,
        align: column.align,
      }))}
      id={Id.assert(inventoryItem.id)}
      name={inventoryItem.name}
      shortId={inventoryItem.shortId}
      override={inventoryItem.override}
      global={inventoryItem.global}
      hidden={inventoryItem.hidden}
      createdByName={inventoryItem.createdBy.displayName}
      createdByAvatar={inventoryItem.createdBy.avatar}
      createdByAvatarFallback={inventoryItem.createdBy.avatarFallback}
      serviceTypeText={vm.serviceTypeText}
      version={inventoryItem.version}
      dateCreated={inventoryItem.dateCreated}
      courtesyAmount={inventoryItem.courtesyAmount}
      priceTypeText={vm.priceTypeText}
      supportingItemsCount={inventoryItem.supportingItemsCount}
      clientPrice={vm.clientPrice}
      proPrice={vm.proPrice}
      hasActions={vm.hasActions}
      canEdit={vm.canEdit}
      canOverride={vm.canOverride}
      canArchive={vm.canArchive}
      canUnarchive={vm.canUnarchive}
      hasWorkspace={vm.hasWorkspace}
      onEdit={vm.edit}
      onOverride={vm.override}
      onArchive={vm.archive}
      onUnarchive={vm.unarchive}
      actionsTestIds={inventoryItemActionsTestIds(inventoryItem.name)}
      testId={`inventory-items-list-item-${inventoryItem.name}`}
    />
  )
})

function inventoryItemActionsTestIds(name: string) {
  return {
    menu: `inventory-item-actions-${name}`,
    update: `inventory-item-actions-update-${name}`,
    override: `inventory-item-actions-override-${name}`,
    archive: `inventory-item-actions-archive-${name}`,
    unarchive: `inventory-item-actions-unarchive-${name}`,
  }
}
